import React from 'react';

export default function LoginForm({ form, onChange, onSubmit, showPassword, onTogglePassword }) {
  return (
    <form onSubmit={onSubmit} className="auth-form">
      <div className="form-field">
        <label>Usuario</label>
        <input
          placeholder="Correo o clave de elector"
          value={form.emailOrIneKey}
          onChange={e => onChange({ ...form, emailOrIneKey: e.target.value })}
          required
        />
      </div>
      <div className="form-field">
        <label>Contraseña</label>
        <div className="input-eye">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="••••••••"
            value={form.password}
            onChange={e => onChange({ ...form, password: e.target.value })}
            required
          />
          <button
            type="button"
            className="eye-btn"
            onClick={onTogglePassword}
            aria-label={showPassword ? 'Ocultar contrasena' : 'Mostrar contrasena'}
          >
            <i className={showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'} aria-hidden="true" />
          </button>
        </div>
      </div>
      <button type="submit" className="btn-primary full">Iniciar sesión</button>
    </form>
  );
}
